// extracted by mini-css-extract-plugin
export var alignBaseline = "_z-9";
export var alignCenter = "_z-5";
export var alignFlexEnd = "_z-7";
export var alignFlexStart = "_z-6";
export var alignSelfBaseline = "_z-e";
export var alignSelfCenter = "_z-a";
export var alignSelfFlexEnd = "_z-c";
export var alignSelfFlexStart = "_z-b";
export var alignSelfStretch = "_z-d";
export var alignStretch = "_z-8";
export var column = "_z-2";
export var columnReverse = "_z-4";
export var flex = "_z-0";
export var justifyCenter = "_z-f";
export var justifyFlexEnd = "_z-h";
export var justifyFlexStart = "_z-g";
export var justifySpaceAround = "_z-j";
export var justifySpaceBetween = "_z-i";
export var justifySpaceEvenly = "_z-k";
export var row = "_z-1";
export var rowReverse = "_z-3";
export var wrapNowrap = "_z-m";
export var wrapWrap = "_z-l";
export var wrapWrapReverse = "_z-n";